import React, {Component} from 'react';
import {XYPlot, LineSeries} from 'react-vis'; // XAxis, YAxis, HorizontalGridLines,
import Iframe from 'react-iframe'
import XYR from '../components/models/xyr/XYR';
import TradeTable from '../components/TradeTable';
import BlockClock from "../components/models/blockclock/BlockClock";

class BasicGraph extends Component {

    constructor() {
        super();
        this.callString = "http://blockhive.io:3001/btc_dates_between?date1=2020-04&date2=2020-05";//"http://localhost:3001/btc_dates_between?date1=2020-04&date2=2020-05";
        //this.my_x_array = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

        this.state = {
            data_points: [],
            data_rsi: [],
            data_updated: false
        };
    }

    update_window = u => {
        this.setState({data_updated: true});
    }

    componentDidMount() {
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        //headers.append('Authorization', 'Basic ' ); //+ base64.encode(username + ":" +  password));
        headers.append('Origin', 'http://localhost');
        headers.append('access-control-allow-origin', "*");

        try {
            fetch(this.callString, {
                mode: 'cors', //'cors',//'no-cors', //'same-origin',//'no-cors',
                method: 'GET',
                cache: 'no-cache',
                credentials: "same-origin",
                //credentials: 'include', // or 'PUT'
                headers: headers
            })
                .then(res => res.json()) // this.my_array = Array.from(
                // JSON.parse(res) // JSON.stringify(res) res.json()
                .then((data) => {
                    //this.setState({ data_points: data });
                    console.log("Type: " + typeof (data));
                    data.forEach(val => console.log(val.tx_time, val.px_in_usd, val.r_value));


                    data.forEach(val => {
                        this.state.data_points.push({
                            "x": Math.round(val.px_in_usd),
                            "y": Math.round(val.r_value)
                        });
                    });

                    for (var i = 0; i < data.length; i++) {
                        this.state.data_rsi.push({
                            x: Math.round(i),
                            y: Math.round(data[i].r_value)
                        });
                        console.log(Math.round(data[i].r_value));
                    }
                    console.log("HERE: " + JSON.stringify(this.state.data_points));

                    this.update_window();
                    //this.refreshShoeList();
                });
            //console.log("Response: " + this.state.data_points);
            /**/
        } catch (e) {
            console.log("Error!: " + e);
        }

        this.setState({data_updated: true});
        console.log("Data points: " + this.state.data_points);
    }

    render() {
        return (
            <div className="BasicGraph">
                <div className="tc2000">
                    <Iframe
                        width="400" noresize="noresize" scrolling="no" height="122"
                        frameborder="0"
                        src="https://widgets.tc2000.com/WidgetServer.ashx?id=180772"
                    />
                </div>
                <XYR/>
                <BlockClock/>
                {/*<TradeTable/>*/}
                {/*<XYPlot height={200} width={200} color="white">*/}
                {/*    <LineSeries*/}
                {/*        data={[*/}
                {/*            {x: 1, y: 10},*/}
                {/*            {x: 2, y: 5},*/}
                {/*            {x: 3, y: 15},*/}
                {/*            {x: 4, y: 8},*/}
                {/*            {x: 5, y: 5},*/}
                {/*            {x: 6, y: 13},*/}
                {/*            {x: 7, y: 7},*/}
                {/*            {x: 8, y: 11},*/}
                {/*            {x: 9, y: 6},*/}
                {/*            {x: 10, y: 13},*/}
                {/*            {x: 11, y: 11},*/}
                {/*            {x: 12, y: 12},*/}
                {/*            {x: 13, y: 8},*/}
                {/*            {x: 14, y: 13}*/}
                {/*        ]}/>*/}
                {/*</XYPlot>*/}
            </div>
        );
    }
}

export default BasicGraph;

